<!--  -->
<template>
  <div>
    <div class="select_box search_box">
      <el-input v-model="query.remark" style="width:400px" placeholder="填写外部员工昵称" />
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="员工名字"
        align="center"
        width="260"
      />
      <el-table-column
        prop="user_id"
        label="企业成员userid"
        align="center"
        width="320"
      />
      <el-table-column
        prop="external_user_id"
        label="外部联系人userid"
        align="center"
        width="320"
      />
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="400"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooser(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { contactFollowUsers } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      employee_no: null,
      query: {
        remark: null,
        page: 1,
        pageSize: 10
      },
      total: null,
      tableData: [],
      loading: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async list() {
      this.loading = true
      const data = await contactFollowUsers({
        ...this.query,
        employee_no: this.employee_no
      })
      this.loading = false
      this.total = data.data.total
      this.tableData = data.data.list
      console.log('data', data)
    },
    customsend(employee_no) {
      this.employee_no = employee_no
      this.list()
    },
    chooser(item) {
      this.$emit('customcallback', item)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.remark = null
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  margin-bottom: 10px;
}
</style>
